module.exports = __webpack_public_path__ + "img/jonathan.c4852069.jpg";